import React from "react";
import {Typography, makeStyles} from "@material-ui/core";

const useStyles = makeStyles({
  htmlContent: {
    wordWrap: "break-word",
    whiteSpace: "break-spaces",
    fontSize: 12,
    "& img": {
      maxWidth: "100%",
    },
    "& p": {
      margin: 0,
    },
  },
});

export default function HTMLContent({v}) {
  const classes = useStyles();
  return (
    <Typography
      className={classes.htmlContent}
      dangerouslySetInnerHTML={{__html: v}}
    />
  );
}
